import { calcularDiasPortaria } from './regras-portaria-ferias';

export function pedidoFeriasAdminValido(funcionarioId?: string, inicio?: string, fim?: string) {
  return !!funcionarioId && calcularDiasPortaria(inicio, fim) > 0;
}
